import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router';
// import { connect } from 'react-redux';
import util from 'util';

const GuestOnly = (props) => {
  // static contextTypes = {
  //   router: PropTypes.object.isRequired
  // }
  const { user } = props;
  const history = useHistory();

  useEffect(() => {
    console.log(props);
    if (user.isLoggedIn) {
      if (props.location.pathname === generatePath(props.children.props.path, { shopId: props.match.params.shopId })) {
        history.replace(generatePath(`${props.match.path}`, { shopId: props.match.params.shopId }));
      }
    }
  }, [user, history, props.location.pathname, props])

  return <div><div className="d-none">{util.inspect(props.location)}</div>{props.children}</div>;
}

GuestOnly.propTypes = {
  children: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

// function select({ auth }) {
//   return { auth };
// }

export default GuestOnly;